import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from 'react-bootstrap/lib/Input';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

const ProfilePaymentCard = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
					title='Payment'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<form className="screen-content section-wrap">
					<div className="section-body">
						<div className="profile-payment-card-price">$15<span className="shy">/ month</span></div>

						<div className="ma-form-section">
							<div className="ma-form-group">
								<div className="ma-form-label">Card <OverlayTrigger overlay={<Tooltip id="expiryInfo">CVC or CVV code is extra code printed on your debit cor credit card. With most cards it is the final three digits of the number printed on the signature strip on the reverse of your card.</Tooltip>}><Glyphicon glyph="question-sign"/></OverlayTrigger></div>
								<div className="ma-form-input">
									<div className="ma-form-split">
										<Input type="text" placeholder="Credit card number"/>
									</div>
									<div className="ma-form-split ma-form-split--third">
										<Input type="text" maxLength="4" placeholder="CVV" pattern="(\d)"/>
									</div>
								</div>
							</div>
							<div className="ma-form-group">
								<div className="ma-form-label">Expiry date <OverlayTrigger overlay={<Tooltip id="expiryInfo">Expiry date information</Tooltip>}><Glyphicon glyph="question-sign"/></OverlayTrigger></div>
								<div className="ma-form-input">
									<div className="ma-form-split ma-form-split--half">
										<Input type="select">
											<option>Month</option>
											<option value="1">01</option>
											<option value="2">02</option>
											<option value="3">03</option>
											<option value="4">04</option>
											<option value="5">05</option>
											<option value="6">06</option>
											<option value="7">07</option>
											<option value="8">08</option>
											<option value="9">09</option>
											<option value="10">10</option>
											<option value="11">11</option>
											<option value="12">12</option>
										</Input>
									</div>
									<div className="ma-form-split ma-form-split--half">
										<Input type="select">
											<option>Year</option>
											<option value="2011">2011</option>
											<option value="2012">2012</option>
											<option value="2013">2013</option>
											<option value="2014">2014</option>
											<option value="2015">2015</option>
											<option value="2016">2016</option>
											<option value="2017">2017</option>
											<option value="2018">2018</option>
											<option value="2019">2019</option>
											<option value="2020">2020</option>
										</Input>
									</div>
								</div>
							</div>
							<div className="ma-form-group">
								<div className="ma-form-label">Card holder</div>
								<div className="ma-form-input">
									<Input type="text"/>
								</div>
							</div>
						</div>

					</div>
					<div className="section-footer">
						<TouchLink to="/profile/payment/cancel" className="profile-payment-cancel-link">Cancel the Subscription</TouchLink>
						<TouchButton type="submit" bsStyle="primary" block>Pay</TouchButton>
					</div>
				</form>
			</div>
		);
	}
});

export default ProfilePaymentCard;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/ProfilePaymentCard.js
 **/